module.exports = __webpack_public_path__ + "img/inactive-keyword.cc4b7583.svg";